// lib
import React from 'react';

// contexts
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

// helpers
import { getActionURLWithPLPFilters } from 'shared/helpers/utils';
import { calculateImageDimensions } from './helpers';

// constants
import { BREAKPOINTS } from 'shared/styles/base';
import { IMAGE_ASPECT_RATIO } from './constants';

// styles
import {
  Product,
  Column,
  Row,
  Title,
  SubTitle,
  Description,
  ProductImage,
  imgClassName,
  ProductImageContainer,
} from './styles';

//def
interface ICAVProduct {
  item: any;
  onClick?: () => void;
}

function CAVProduct({ item, onClick }: ICAVProduct) {
  const { deviceWidth } = useResponsiveContext();
  const isMobile = deviceWidth < BREAKPOINTS.DESKTOP;

  const [image1, image2, image3] = item.images;
  // defensive check
  if (!image1 || !image2 || !image3) {
    return null;
  }

  const action_url = getActionURLWithPLPFilters(item, 'action_url');
  const targetValue = isMobile ? '_self' : '_blank';

  const { productWidth, productPadding, bigImageWidth, smallImageWidth } = calculateImageDimensions(
    deviceWidth,
    isMobile
  );

  const onProductClick = (event: MouseEvent) => {
    event.preventDefault();

    onClick && onClick();
    window.location.href = action_url;
  };

  return (
    <Product
      href={action_url}
      target={targetValue}
      width={productWidth}
      padding={productPadding}
      isMobile={isMobile}
      onClick={onProductClick}
    >
      <Row>
        <ProductImageContainer className="big-image" containerWidth={bigImageWidth}>
          <ProductImage
            src={image1}
            alt={`${item.title} - ${item.subTitle}`}
            data-test="image-component"
            width={bigImageWidth}
            aspectRatio={IMAGE_ASPECT_RATIO}
            className={imgClassName}
          />
        </ProductImageContainer>
        <Column>
          <ProductImageContainer containerWidth={smallImageWidth}>
            <ProductImage
              src={image2}
              alt={`${item.title} - ${item.subTitle}`}
              data-test="image-component"
              width={smallImageWidth}
              aspectRatio={IMAGE_ASPECT_RATIO}
              className={imgClassName}
            />
          </ProductImageContainer>
          <ProductImageContainer containerWidth={smallImageWidth}>
            <ProductImage
              src={image3}
              alt={`${item.title} - ${item.subTitle}`}
              data-test="image-component"
              width={smallImageWidth}
              aspectRatio={IMAGE_ASPECT_RATIO}
              className={imgClassName}
            />
          </ProductImageContainer>
        </Column>
      </Row>

      <Description>
        <Title>{item.title}</Title>
        <SubTitle>{item.subTitle}</SubTitle>
      </Description>
    </Product>
  );
}

export default CAVProduct;
